<template>
  <div class="community-wizard-view">
    <community-wizard
      :is-owner-flow="isOwnerFlow"
      @close="handleClose"
      @community-created="onCommunityCreated"
      @show-all-set-modal="onShowAllSetModal"
    />

    <!-- All Set Modal -->
    <all-set-modal
      v-if="showAllSetModal"
      @close="closeAllSetModal"
      @start-tour="startTour"
    />
  </div>
</template>

<script>
import CommunityWizard from '../components/CommunityWizard/CommunityWizard.vue'
import AllSetModal from '../components/CommunityWizard/AllSetModal.vue'

export default {
  name: 'CommunityWizardView',
  components: {
    CommunityWizard,
    AllSetModal
  },
  data() {
    return {
      showAllSetModal: false
    }
  },
  computed: {
    isOwnerFlow() {
      // Get flow type from route query param, default to true (owner flow)
      return this.$route.query.flow !== 'assign'
    }
  },
  methods: {
    handleClose() {
      // Navigate back to clubs list
      this.$router.push('/clubs')
    },

    onCommunityCreated(club) {
      console.log('Community created successfully:', club)
    },

    onShowAllSetModal() {
      this.showAllSetModal = true
    },

    closeAllSetModal() {
      this.showAllSetModal = false
      // Navigate back to clubs
      this.$router.push('/clubs')
    },

    startTour() {
      console.log('Starting community tour...')
      this.showAllSetModal = false
      this.$router.push('/clubs')
    }
  }
}
</script>

<style lang="scss" scoped>
.community-wizard-view {
  // Remove default content padding from broker layout
  // App.vue uses: padding: 48px 48px 24px 48px (no-breadcrumb class)
  margin: -48px -48px -24px -48px;
  min-height: 100vh;
  background: white;

  // Tablet: App.vue uses padding: 72px 24px 24px 24px
  @media (min-width: 600px) and (max-width: 959px) {
    margin: -72px -24px -24px -24px;
  }
}
</style>
